
export const PLAYER_BG_REQUEST = 'PLAYER_BG_REQUEST';
export const PLAYER_BG_SUCCESS = 'PLAYER_BG_SUCCESS';
export const PLAYER_BG_ERROR   = 'PLAYER_BG_ERROR';

export const LEAVE_TEAM_REQUEST = 'LEAVE_TEAM_REQUEST';
export const LEAVE_TEAM_SUCCESS = 'LEAVE_TEAM_SUCCESS';
export const LEAVE_TEAM_ERROR   = 'LEAVE_TEAM_ERROR';
